import React, { Component } from 'react';
import { Grid, Divider, Tab, Button, Header, Icon, Modal } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
import PointTab from './tabs/point-tab';
import Structure from './tabs/minor-structs/structure'
import Condition from './tabs/minor-structs/condition'
import Signing from './tabs/minor-structs/signing'
import PhotoGallery from './tabs/minor-structs/photogallery2'
import '../index.css';
import $ from 'jquery';
import config from '../config.json';

export default class MinorStructures extends Component {

    constructor(props) {
        super(props);
        if (this.props.loadData) {
            console.log(this.props.loadData)
            this.state = {
                MinorStructures: this.props.loadData
            };
        }
        else {
            // This is a super data model class, its main function is to collect data from all the children components.
            this.state = {
                MinorStructures: {
                    layer: 3,
                    layerName: 'MinorStructures',
                    layerId: -1,
                    agencyId: -1, //to be determined later
                    FlagForGallery: 1,

                    point: {
                        id: -1, //id is not set, will be setting it soon.
                        point: '0,0',
                        structureNumber: '',
                        pointDescription: '',
                        inlet: '0,0',
                        outlet: '0,0',
                        inletElevation: 0,
                        outletElevation: 0,
                        approachStruct: 0
                    },

                    structure: {
                        structType: 0,
                        material: 0,
                        spanLength: "0",

                        cellDiameter: "0",
                        cellWidth: "0",
                        cellHeight: "0",
                        cellLength: "0",

                        numberOfCells: 0,
                        yearInstalled: "0",
                        depthOfCover: "0",

                        aprons: 0,
                        bevel: 0,

                        replacementCost: "0",
                        owner: 0
                    },

                    condition: {
                        erosion: 0,
                        roadway: 0,
                        waterwayFlow: 0,
                        overallStructure: 0,
                        ratingDate: null
                    },
                    signing: {

                        allConfigGVW: 0,
                        allConfigPerAxel: 0,
                        singleUnitGVW: 0,
                        singleUnitPerAxel: 0,
                        doubleUnitGVW: 0,
                        doubleUnitPerAxel: 0,
                        multipleUnitGVW: 0,
                        multipleUnitPerAxel: 0,
                        bridgeEndMarker: 0
                    },
                    galleryModel: {
                        Comments: [],
                        datecreated: [],
                        key: [],
                        photpath: [],
                        photos: []
                    }

                }
            };
        }
        this.panes = [
            {
                menuItem: 'Location', render: () =>
                    <Tab.Pane>
                        <PointTab clickFunctions={this.props.clickFunctions}
                            triggerNeedSave={this.props.triggerNeedSave}
                            disabled={this.props.disabled}
                            pointModel={this.state.MinorStructures.point} />
                    </Tab.Pane>
            },
            {
                menuItem: 'Structure', render: () =>
                    <Tab.Pane>
                        <Structure triggerNeedSave={this.props.triggerNeedSave}
                            disabled={this.props.disabled}
                            minorModel={this.state.MinorStructures} />
                    </Tab.Pane>
            },
            {
                menuItem: 'Condition', render: () =>
                    <Tab.Pane>
                        <Condition triggerNeedSave={this.props.triggerNeedSave}
                            disabled={this.props.disabled}
                            minorModel={this.state.MinorStructures} />
                    </Tab.Pane>
            },
            {
                menuItem: 'Signing', render: () =>
                    <Tab.Pane>
                        <Signing triggerNeedSave={this.props.triggerNeedSave}
                            disabled={this.props.disabled}
                            minorModel={this.state.MinorStructures} />
                    </Tab.Pane>
            },
            {
                menuItem: 'Photo Gallery', render: () =>
                    <Tab.Pane>
                        <PhotoGallery triggerNeedSave={this.props.triggerNeedSave}
                            disabled={this.props.disabled}
                            loggedIn={this.props.loggedin}
                            showLoadingSpinner={this.props.showSpinner}
                            minorModel={this.state.MinorStructures} />
                    </Tab.Pane>
            },
        ];

        this.props.dataModel.splice(0, this.props.dataModel.length);
        this.props.dataModel.push(this.state.MinorStructures);
    }

    renderGritLayerUI = () => {
        return (
            <div>
                {/* <Grid.Row>
                    <h5>Minor Structures</h5>
                </Grid.Row> */}
                <Divider style={{ marginTop: -3 }} />
                <Grid.Row>
                    <Tab panes={this.panes} activeIndex={this.props.activeIndex} onTabChange={this.onTabChange} />
                </Grid.Row>
                <br/>
                {(!this.state.MinorStructures.structure.updated && this.props.loggedin) && <Button size='tiny' onClick={(e) => {this.onApprove()}} color='red'>Approve</Button>}

            </div>
        );
    }

    onApprove = () =>{
        console.log(this.state.MinorStructures)
        $.ajax({
            type: 'POST',
            url: `${config.server}\\approveminorstructure`,
            contentType: 'application/json',
            data: JSON.stringify({layerId: this.state.MinorStructures.layerId}),

            success: (data) => {
                console.log('Success data ', data)

                let temp = this.state.MinorStructures
                temp.structure.updated = 1

                this.setState({MinorStructures: temp})                
                this.props.clickFunctions.updateMSMarker(this.state.MinorStructures.point.id)

                this.props.markerApprove()
            },
            error: function (textStatus, errorThrown) {
                alert('Error: Failed to update')
                console.log(errorThrown)
            }
        });
    }

    onTabChange = (e, data) => {
        this.props.updateActiveIndex(data.activeIndex);
    }

    updateState = () => {
        this.setState({ state: this.state })
    }

    render() {
        return this.renderGritLayerUI();
    }
}


// WEBPACK FOOTER //
// ./src/layers/minor-structs.js